/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdviserJobMaster } from '../models/AdviserJobMaster';
import type { AreaMaster } from '../models/AreaMaster';
import type { EventCategoryMaster } from '../models/EventCategoryMaster';
import type { RouteToKnowMaster } from '../models/RouteToKnowMaster';
import type { StartupBusinessTypeMaster } from '../models/StartupBusinessTypeMaster';
import type { StartupPlanMaster } from '../models/StartupPlanMaster';
import type { StartupStageMaster } from '../models/StartupStageMaster';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MasterDataService {

    /**
     * Get Master Data list API Endpoint
     * Get Master Data list
     * @returns any successful operation
     * @throws ApiError
     */
    public static masterDataList(): CancelablePromise<{
status?: number;
message?: string;
data?: {
adviserJobMasters?: Array<AdviserJobMaster>;
areaMasters?: Array<AreaMaster>;
startupStageMasters?: Array<StartupStageMaster>;
startupPlanMasters?: Array<StartupPlanMaster>;
routeToKnowMasters?: Array<RouteToKnowMaster>;
startupBusinessTypeMasters?: Array<StartupBusinessTypeMaster>;
eventCategoryMasters?: Array<EventCategoryMaster>;
};
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/master_data',
            errors: {
                500: `Internal Server error`,
            },
        });
    }

}
